// extracted by mini-css-extract-plugin
export var drawerPaper = "_23-0";
export var itemImage = "_23-1";